
import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Bridge route for /license:
 * - Immediately opens the global overlay and navigates back to the previous page.
 * - Works even on hard-refresh to /license (stays and shows overlay).
 */
export default function LicenseRouteBridge() {
  const nav = useNavigate();
  const [shown, setShown] = React.useState(false);

  React.useEffect(() => {
    // Open overlay
    window.dispatchEvent(new CustomEvent('open-license'));
    setShown(true);
    // If there is history, go back to previous route so overlay sits on the real page
    // Delay a tick to allow overlay to mount
    setTimeout(() => {
      if (window.history.length > 1) {
        nav(-1);
      }
    }, 0);
  }, [nav]);

  // Render nothing (overlay is global). Provide minimal fallback link.
  return (
    <div style={{padding:'24px'}}>
      {shown ? <p>Opening license overlay…</p> : null}
    </div>
  );
}
